import _ from "lodash";
import Axios from "axios";

export const FilterData = {
    getters: {
        filterByProject: (state, commit, rootState)=>{
            return _.filter(state.items, (o) => {
                return typeof (o.projectType) !== 'undefined' && o.projectType.altName == rootState.type
            })
        }
    }
}
export const Data = {
    actions:{
        getItems({state, commit, rootState}){
            const path = rootState.api + state.api.main + '.json?eoId=' + rootState.eoId
            return new Promise((resolve, reject) => {
                Axios({
                    method: 'GET',
                    url: path
                }).then( res =>{
                    if(res.status == 200 && res.data.result == 'success'){
                        commit('setItems', res.data.data)
                        resolve(res)
                    } else {
                        reject(res)
                    }
                }).catch( err => {
                    reject(err)
                })
            })


        }
    }
}
